import { render, staticRenderFns } from "./Rim.vue?vue&type=template&id=6dbb26df"
import script from "./Rim.vue?vue&type=script&lang=js"
export * from "./Rim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports